

  <div class="page pb-o" *ngIf="this.aboutUsPage && this.isLoaded">
    <div class="page-content">
      <div class="about-us-wrapper">
        <div class="container">
          <c-page [page]="this.aboutUsPage"></c-page>
        </div>
      </div>
    </div>
  </div>


<div class="page pb-0" *ngIf="!this.aboutUsPage && this.isLoaded">
  <div class="container-fluid p-0">
    <div class="breadcrumb-generic breadcrumb-generic--overlay" style="background-image: url('./assets/images/bg_about-us.jpg');">
      <div class="container-sm">
        <h1 class="breadcrumb-generic__title">Chi Siamo</h1>
      </div>
    </div>
  </div>
  <div class="page-content about-us">
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-6">
          <div class="e-title e-title__with-divider">
            <h2>Chi siamo</h2>
            <hr class="hr hr--heavy hr--brand hr--title mb-2">
            <!--      <p>In hac habitasse platea dictumst. Vivamus adipiscing fermentum quam volutpat aliquam. Integer et elit eget elit facilisis tristique. Nam vel iaculis mauris. Sed ullamcorper tellus erat, non ultrices sem tincidunt euismod. Fusce rhoncus porttitor velit, eu bibendum nibh aliquet vel. Fusce lorem leo, vehicula at nibh quis,.</p>-->
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col" [innerHTML]="legacyAboutUs">
        </div>
      </div>
    </div>
  </div>
</div>
